var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 53,
    viewBox: "0 0 32 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.837448 52.1285C1.10238 52.396 1.41706 52.6082 1.76349 52.753C2.10992 52.8978 2.48129 52.9724 2.85634 52.9724C3.23139 52.9724 3.60276 52.8978 3.94919 52.753C4.29562 52.6082 4.6103 52.396 4.87523 52.1285L15.9863 40.9614L27.126 52.1574C27.3911 52.4245 27.7058 52.6364 28.0522 52.781C28.3986 52.9256 28.7699 53 29.1449 53C29.5198 53 29.8911 52.9256 30.2375 52.781C30.5839 52.6364 30.8986 52.4245 31.1637 52.1574C31.4289 51.8902 31.6392 51.5731 31.7827 51.224C31.9262 50.875 32 50.5008 32 50.123C32 49.7452 31.9262 49.3711 31.7827 49.0221C31.6392 48.673 31.4289 48.3559 31.1637 48.0887L18.0195 34.844C16.9027 33.7187 15.0985 33.7187 13.9817 34.844L0.837449 48.0887C0.572159 48.3528 0.361531 48.6673 0.217776 49.0141C0.0740207 49.3608 2.85624e-07 49.7328 2.52773e-07 50.1086C2.19922e-07 50.4844 0.0740206 50.8564 0.217776 51.2031C0.36153 51.5499 0.572159 51.8644 0.837448 52.1285Z",
    fill: "url(#paint0_linear_1420_14)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.841797 35.1285C1.10693 35.396 1.42186 35.6082 1.76856 35.753C2.11526 35.8978 2.48692 35.9724 2.86227 35.9724C3.23761 35.9724 3.60927 35.8978 3.95597 35.753C4.30267 35.6082 4.61759 35.396 4.88273 35.1285L16.0024 23.9614L27.1222 35.1574C27.658 35.6969 28.3848 36 29.1426 36C29.9005 36 30.6272 35.6969 31.1631 35.1574C31.699 34.6178 32 33.8861 32 33.123C32 32.36 31.699 31.6283 31.1631 31.0887L18.0086 17.844C16.8909 16.7187 15.0854 16.7187 13.9677 17.844L0.813143 31.0887C0.287004 31.6294 -0.005293 32.3577 7.6125e-05 33.1146C0.00544525 33.8715 0.308042 34.5955 0.841797 35.1285Z",
    fill: "url(#paint1_linear_1420_14)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.841798 18.1285C1.10693 18.396 1.42186 18.6082 1.76856 18.753C2.11526 18.8978 2.48692 18.9724 2.86227 18.9724C3.23761 18.9724 3.60927 18.8978 3.95597 18.753C4.30267 18.6082 4.61759 18.396 4.88273 18.1285L16.0025 6.9614L27.1222 18.1574C27.658 18.6969 28.3848 19 29.1426 19C29.9005 19 30.6272 18.6969 31.1631 18.1574C31.699 17.6178 32 16.8861 32 16.123C32 15.36 31.699 14.6283 31.1631 14.0887L18.0086 0.844023C16.8909 -0.281343 15.0854 -0.281343 13.9677 0.844023L0.813144 14.0887C0.287006 14.6294 -0.00529151 15.3577 7.76112e-05 16.1146C0.00544673 16.8715 0.308044 17.5955 0.841798 18.1285Z",
    fill: "url(#paint2_linear_1420_14)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1420_14",
    x1: 16,
    y1: 62,
    x2: 16,
    y2: -31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.142498,
    stopColor: "#0E3744"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.663362,
    stopColor: "#FBA346"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1420_14",
    x1: 16,
    y1: 62,
    x2: 16,
    y2: -31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.142498,
    stopColor: "#0E3744"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.663362,
    stopColor: "#FBA346"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1420_14",
    x1: 16,
    y1: 62,
    x2: 16,
    y2: -31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.142498,
    stopColor: "#0E3744"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.663362,
    stopColor: "#FBA346"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow-up.501099c174d1e0f9a2bb79fed494b22d.svg";
export { ForwardRef as ReactComponent };